export const drawArrow = (ctx, startX, startY, endX, endY, height = '10', type = 'single') => {
  let dx = endX - startX
  let dy = endY - startY
  let len = Math.sqrt(dx * dx + dy * dy)
  const arrowHeadSize = {
    x: 20,
    y: height * 2
  }
  let controlPoints = null
  if (type === 'single') {
    controlPoints = [
      0,
      height,
      -arrowHeadSize.x,
      height,
      -arrowHeadSize.x,
      arrowHeadSize.y
    ]
  }
  switch (type) {
    case 'single':
      controlPoints = [
        0,
        height,
        -arrowHeadSize.x,
        height,
        -arrowHeadSize.x,
        arrowHeadSize.y
      ]
      break
    case 'double':
      controlPoints = [
        arrowHeadSize.x,
        arrowHeadSize.y,
        arrowHeadSize.x,
        height,
        -arrowHeadSize.x,
        height,
        -arrowHeadSize.x,
        arrowHeadSize.y
      ]
      break
  }
  let sin = dy / len
  let cos = dx / len
  let a = []
  a.push(0, 0)
  for (let i = 0; i < controlPoints.length; i += 2) {
    let x = controlPoints[i]
    let y = controlPoints[i + 1]
    a.push(x < 0 ? len + x : x, y)
  }
  a.push(len, 0)
  for (let i = controlPoints.length; i > 0; i -= 2) {
    let x = controlPoints[i - 2]
    let y = controlPoints[i - 1]
    a.push(x < 0 ? len + x : x, -y)
  }

  a.push(0, 0)

  for (let i = 0; i < a.length; i += 2) {
    let x = a[i] * cos - a[i + 1] * sin + startX
    let y = a[i] * sin + a[i + 1] * cos + startY
    if (i === 0) ctx.moveTo(x, y)
    else ctx.lineTo(x, y)
  }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/drawArrow.js